exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cashbox-list__table[data-v-20fb6f98] {\n  margin-top: 1.5rem;\n}\n\n/* .cashbox-list__view-details-btn {\n   float: right;\n }*/\n.cashbox-list__no-withdraws[data-v-20fb6f98] {\n  margin: 1rem auto;\n  text-align: center;\n}\n.status-cell[data-v-20fb6f98] {\n  width: 20%;\n}\n.source-cell[data-v-20fb6f98], .destination-cell[data-v-20fb6f98] {\n  width: 15%;\n}\n.requestor-cell[data-v-20fb6f98] {\n  width: 30%;\n}\n.date-cell[data-v-20fb6f98] {\n  width: 15%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20fb6f98","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/cashbox/index/Cashbox.List.vue
// module id = RxnS
// module chunks = 1